/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [update-account.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 03.01.20, 09:01
 */
import React, {Fragment, useEffect} from 'react';
import {useAuthorization} from "../../../selectors";
import {useLanguage} from "../../configuration/configuration";
import useFetchQRCode from "../../hooks/use-fetch-qrcode";
import {SUCCESS_STATUS} from "../../../actions";
import {Spinner} from "../../util/spinner";
import {QRCode} from "../space/show-qrcode-dialog";
import DialogBox from "../dialog-box";
import {DigitalCardIcon} from "../../navigation/icons/nav-icons";

const ShowDigitalCard = ({isOpen, setIsOpen}) => {
    const {isAuthorized, principalUsername} = useAuthorization();
    const {fetchAccountQrCode, qrCode, status} = useFetchQRCode();
    const Lang = useLanguage();

    useEffect(() => {
        isAuthorized && fetchAccountQrCode(principalUsername);
    }, [principalUsername]);

    if (isAuthorized && status !== SUCCESS_STATUS) return <Spinner/>

    return <DialogBox title={Lang.nav.submenu.digitalCard.title}
                      action={null}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      isDisabled={!isAuthorized}
                      callback={null}>

        <div className='update-account-container'>
            <div className='update-account-formss mb-4'>
                <div className='font-1x text-bolder mx-5 mb-2'>{Lang.qrcode.update.title}</div>
                <div className='digital-card-container mx-5'>
                    <div className='digital-card-container-header'>{isAuthorized ? qrCode.siteName : 'Not Authorized'}</div>
                    <div className='digital-card-container-body'>

                        {isAuthorized && <Fragment>
                            <div className='digital-card-container-svg'>
                                <QRCode qrCode={qrCode.svgQrCode}/>
                            </div>
                            <div className='digital-card-container-text'>
                                <div className='mb-2'>{qrCode.fullname}</div>
                                <div>{Lang.qrcode.update.memberSince} {qrCode.memberSince}</div>
                                <div>{Lang.qrcode.update.validUntil} {`${qrCode.validUntil ? qrCode.validUntil : '-'}`}</div>
                                <div>{qrCode.siteName}</div>
                                <div>{Lang.qrcode.update.web} {qrCode.siteUrl}</div>
                                <div className='digital-card-container-membership mt-1'>
                                    {qrCode.membership} {Lang.qrcode.member.membership}
                                </div>
                            </div>
                        </Fragment>}

                        {!isAuthorized && <Fragment>
                            <div className='digital-card-container-svg'>
                                <DigitalCardIcon fontSize='large' color='error'/>
                            </div>
                            <div className='digital-card-container-text'>
                                <div className='mb-2'>{Lang.nav.submenu.digitalCard.notAuthorized}</div>
                            </div>
                        </Fragment>}

                    </div>
                </div>

            </div>
        </div>

    </DialogBox>
};

export default ShowDigitalCard;

